export const ORDERS_ORDER_TYPE = "orders_order_type"; // Количество заказов по типу заказа, произведенных в филиале
export const ORDERS_EMPLOYEE = "orders_employee"; // Количество заказов, закрепленных за сотрудником
export const ORDERS_OFFICE = "orders_office"; // Количество заказов, произведенных в филиале
export const PROCEEDS_EMPLOYEE = "proceeds_employee"; // Оборот товаров, закреплённых за сотрудником
export const PROCEEDS_OFFICE = "proceeds_office"; // Оборот филиала
export const PROCEEDS_CATEGORY = "proceeds_category"; // Оборот филиала по категориям
export const PROCEEDS_PLACE = "proceeds_place"; // Оборот филиала по месту приготовления
export const PROCEEDS_ORDER_TYPE = "proceeds_order_type"; // Оборот филиала по типу заказа
export const PROCEEDS_ENTERPRISE = "proceeds_enterprise"; // Объём товара по всему предприятию
export const PRODUCTS_OFFICE = "products_office"; // Объём товара по категориям
export const PRODUCTS_PLACE = "products_place"; // Объём товара по местам приготовления
export const PAYDAY = "payday"; // Оплата за смену
export const PAYHOUR = "payhour"; // Оплата за час
